import { GenericDatabase } from './GenericDatabase'

const DB_NAME = 'Activities'
const DB_VERSION = 1
const STORE_NAME = 'Activity'

const dbInstance = new GenericDatabase(DB_NAME, DB_VERSION, [
    { name: STORE_NAME, keyPath: 'id' }
])

const initDbActivities = () => {
    return dbInstance.init()
}

const agregar = (data, database) => {
    return dbInstance.add(STORE_NAME, data, database)
}

const obtener = (clave, database) => {
    // Original seemed to do nothing on success. Returning the actual object.
    return dbInstance.get(STORE_NAME, clave, database)
}

const actualizar = (data, database) => {
    return dbInstance.put(STORE_NAME, data, database)
}

const eliminar = (clave, database) => {
    // Original called consultar() on success, which would re-fetch all.
    // We will just delete. If a re-fetch is needed, caller should do it.
    return dbInstance.delete(STORE_NAME, clave, database)
}

const consultar = (database) => {
    return dbInstance.getAll(STORE_NAME, database)
}

export default {
    initDbActivities,
    agregar,
    obtener,
    actualizar,
    eliminar,
    consultar
}
